import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import SortIcon from "@mui/icons-material/Sort";
import { Box, Button } from "@mui/material";
import React from "react";

import {
  filterControlButtonStyles,
  FilterMenuButton,
  type FilterMenuOption,
} from "@/components/common/FilterMenuButton";

export type SortDirection = "asc" | "desc";

interface SortSelectorControlProps<T extends string> {
  value: T;
  options: FilterMenuOption<T>[];
  onChange: (value: T) => void;
  direction: SortDirection;
  onDirectionChange: (direction: SortDirection) => void;
  label: string;
  menuTitle: string;
  directionAriaLabel: string;
  directionTitle?: string;
  dropdownDisabled?: boolean;
  directionDisabled?: boolean;
}

export function SortSelectorControl<T extends string>({
  value,
  options,
  onChange,
  direction,
  onDirectionChange,
  label,
  menuTitle,
  directionAriaLabel,
  directionTitle,
  dropdownDisabled = false,
  directionDisabled = false,
}: SortSelectorControlProps<T>) {
  return (
    <Box
      data-record-sort=""
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        width: { xs: "100%", md: "auto" },
        minWidth: 0,
        "& > button:first-of-type": { flex: { xs: "1 1 0", md: "1 0 auto" } },
      }}
    >
      <FilterMenuButton
        selectedValue={value}
        options={options}
        onChange={onChange}
        icon={<SortIcon />}
        label={label}
        menuTitle={menuTitle}
        disabled={dropdownDisabled}
        minWidth={{ xs: "0px", md: "180px" }}
        maxWidth={{ xs: "none", md: "280px" }}
      />
      <Button
        type="button"
        variant="outlined"
        size="small"
        onClick={() => onDirectionChange(direction === "asc" ? "desc" : "asc")}
        disabled={directionDisabled}
        aria-label={directionAriaLabel}
        title={directionTitle}
        sx={{
          ...filterControlButtonStyles,
          minWidth: 40,
          width: 40,
          flexShrink: 0,
          px: 0,
          display: "inline-flex",
          justifyContent: "center",
          alignItems: "center",
          "& .MuiSvgIcon-root": {
            color: "text.secondary",
          },
        }}
      >
        {direction === "asc" ? (
          <ArrowUpwardIcon sx={{ fontSize: 18 }} />
        ) : (
          <ArrowDownwardIcon sx={{ fontSize: 18 }} />
        )}
      </Button>
    </Box>
  );
}
